var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplash2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "575px",
    height: "449px",
    viewBox: "0 0 575 449",
    style: {
      enableBackground: "new 0 0 575 449"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6557B2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#7F6DC6;}\n\t.st3{fill:#BCDEFF;}\n\t.st4{fill:#34A7F0;}\n\t.st5{opacity:0.4;fill:#75D6FD;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.4,242.4c-0.8,0-1.5-0.2-2.2-0.6c-0.7-0.4-1.3-0.9-1.7-1.5c-0.4-0.6-0.7-1.4-0.8-2.1 c-0.1-0.8,0-1.5,0.3-2.2c0.3-0.7,0.8-1.3,1.3-1.8c0.6-0.5,1.3-0.8,2-1c0.8-0.1,1.5-0.1,2.3,0.1c0.7,0.2,1.4,0.6,1.9,1.2 c0.7,0.7,1.1,1.5,1.3,2.4c0.2,0.9,0.1,1.8-0.3,2.7c-0.4,0.9-1,1.6-1.7,2.1C473.2,242.1,472.3,242.4,471.4,242.4z M471.4,234.7 c-0.7,0-1.4,0.2-1.9,0.7c-0.5,0.4-0.9,1.1-1,1.8c-0.1,0.7,0,1.4,0.3,2c0.3,0.6,0.9,1.1,1.5,1.4c0.6,0.3,1.4,0.3,2,0.1 c0.7-0.2,1.2-0.6,1.6-1.2c0.4-0.6,0.6-1.3,0.5-2c-0.1-0.7-0.4-1.3-0.9-1.8c-0.3-0.3-0.6-0.5-1-0.7 C472.2,234.8,471.8,234.7,471.4,234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.4,202.2c-0.1,0-0.2,0-0.3-0.1s-0.2-0.1-0.3-0.2l-9.1-9.1c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.2s0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1s0.2,0.1,0.3,0.2l9.1,9.1 c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2,0,0.3,0,0.5c-0.1,0.1-0.2,0.3-0.3,0.4C449.8,202.1,449.6,202.2,449.4,202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.3,202.2c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.1-0.3,0-0.5c0-0.2,0.1-0.3,0.2-0.4 l9.1-9.1c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6l-9.1,9.1 c-0.1,0.1-0.2,0.1-0.3,0.2S440.4,202.2,440.3,202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.6,182c0,0-0.1,0-0.1,0l6.3,6.5l6.2-1.6l-6.3-6.5L451.6,182z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M449.8,184.9l1.2,4.8l0.4,0.5l6.2-1.6l-6.3-6.5c-0.6,0.2-1.1,0.6-1.4,1.1C449.8,183.7,449.7,184.3,449.8,184.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M463.9,178.8l6.3,6.5l6.2-1.6l-6.3-6.5L463.9,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M457.7,180.4l6.3,6.5l6.2-1.6l-6.3-6.5L457.7,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.4,175.5l6.3,6.5l6.2-1.6l-6.3-6.5L476.4,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M470.1,177.2l6.3,6.5l6.2-1.6l-6.3-6.5L470.1,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M488.8,172.3l6.3,6.5l6.2-1.6l-6.3-6.5L488.8,172.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M482.6,173.9l6.3,6.5l6.2-1.6l-6.3-6.5L482.6,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M503,168.6l-1.7,0.4l5.9,6.1l-1.2-4.8c-0.2-0.6-0.6-1.1-1.1-1.5C504.3,168.6,503.6,168.5,503,168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M495.1,170.7l6.3,6.5l5.9-1.5l-0.1-0.5l-5.9-6.1L495.1,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M447.2,189l-22,38.4c-0.3,0.6-0.4,1.2-0.2,1.8c0.2,0.6,0.6,1.1,1.1,1.4l46.1,26.4c0.6,0.3,1.2,0.4,1.8,0.2 c0.6-0.2,1.1-0.6,1.5-1.1l22-38.4L447.2,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.8,215.1l-13.8,24.1c-1.7,3-4.5,5.1-7.8,6c-3.3,0.9-6.8,0.5-9.8-1.2L427,224.2l-1.8,3.2 c-0.3,0.6-0.4,1.2-0.2,1.8c0.2,0.6,0.6,1.1,1.1,1.4l46.1,26.4c0.6,0.3,1.2,0.4,1.8,0.2c0.6-0.2,1.1-0.6,1.5-1.1l22-38.4 L492.8,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M458.7,195.3l-5.6-3.2l-7.8,4.6l5.6,3.2L458.7,195.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M447.6,188.9l-0.5,0.3l-3.6,6.4l2,1.1l7.8-4.6L447.6,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M462.1,206.3l7.8-4.6l-5.6-3.2l-7.8,4.6L462.1,206.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.5,203.1l7.8-4.6l-5.6-3.2l-7.8,4.6L456.5,203.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M473.3,212.7l7.8-4.6l-5.6-3.2l-7.8,4.6L473.3,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.7,209.5l7.8-4.6l-5.6-3.2l-7.8,4.6L467.7,209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M484.5,219.1l7.8-4.6l-5.6-3.2l-7.8,4.6L484.5,219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.9,215.9l7.8-4.6l-5.6-3.2l-7.8,4.6L478.9,215.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M493.7,224.4l3.7-6.4l-7.3,4.3L493.7,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.1,222.3l7.3-4.3l0.3-0.4l-5.3-3.1l-7.8,4.6L490.1,222.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M455.6,202l-12.6-7.2c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1l7.2-12.7c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0 l5.3,3.1c2,1.1,3.4,3,4,5.2c0.6,2.2,0.3,4.6-0.8,6.5l-3,5.3c0,0.1-0.1,0.1-0.1,0.1S455.7,202,455.6,202z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.2,186.8c0.2,1.8-0.2,3.5-1.1,5.1l0,0c-0.8,1.5-2.2,2.5-3.8,3c-1.6,0.4-3.3,0.2-4.8-0.6l-4-2.3l-1.5,2.5 c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1l12.6,7.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.1-0.1l3-5.3c0.9-1.5,1.2-3.3,1.1-5 C459.9,189.8,459.3,188.2,458.2,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M452.8,187.4c-0.2,0.3-0.4,0.5-0.6,0.6c-0.3,0.1-0.6,0.2-0.9,0.1c-0.3,0-0.6-0.2-0.8-0.4 c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.1-0.6,0-0.9s0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0,0.9,0.2 c0.2,0.1,0.3,0.2,0.5,0.4c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0,0.6C453,187.1,452.9,187.2,452.8,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M449,194.1c-0.2,0.3-0.4,0.5-0.6,0.6c-0.3,0.1-0.6,0.2-0.9,0.1c-0.3,0-0.6-0.2-0.8-0.4 c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.1-0.6,0-0.9c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.3,0.8-0.3c0.3,0,0.6,0,0.9,0.2 c0.4,0.2,0.6,0.5,0.7,0.9C449.2,193.3,449.2,193.8,449,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M455.8,197.9c0.4-0.8,0-1.7-0.7-2c-0.8-0.4-1.7,0-2,0.7c-0.4,0.8,0,1.7,0.7,2 C454.5,199,455.5,198.7,455.8,197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.1,247.2l-36.5-20.9c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.2,0-0.4,0.1-0.6l0,0c0.1-0.2,0.3-0.3,0.5-0.4 c0.2-0.1,0.4,0,0.6,0.1l36.5,20.9c0.2,0.1,0.3,0.3,0.4,0.5s0,0.4-0.1,0.6c-0.1,0.2-0.3,0.3-0.5,0.4 C472.5,247.3,472.3,247.3,472.1,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.1,240.2L434,229.3c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.2,0-0.4,0.1-0.6c0.1-0.2,0.3-0.3,0.5-0.4 c0.2-0.1,0.4,0,0.6,0.1l19.1,10.9c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.3,0.3-0.5,0.4 C453.5,240.3,453.3,240.3,453.1,240.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.5,214.8c-1.7-1-3.6-1.4-5.6-1.3c-1.9,0.1-3.8,0.8-5.4,2c-1.5,1.2-2.7,2.8-3.3,4.7 c-0.6,1.9-0.7,3.8-0.2,5.7c0.5,1.9,1.6,3.6,3,4.9c1.5,1.3,3.3,2.1,5.2,2.3c1.9,0.2,3.9-0.1,5.7-1c1.7-0.9,3.2-2.2,4.2-3.9 c1.3-2.3,1.6-5,1-7.5C470.4,218.2,468.7,216.1,466.5,214.8z M466.2,227l-9.9-0.6c-0.2,0-0.3-0.1-0.5-0.1c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.2,0-0.3,0.1-0.5l4.4-7.7c0.1-0.1,0.2-0.3,0.3-0.3c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.5,0.1 s0.3,0.2,0.4,0.3l5.5,8.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2,0,0.3-0.1,0.5c-0.1,0.2-0.2,0.3-0.4,0.4C466.6,227,466.4,227,466.2,227z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M442.6,208.6c6-6,6-15.7,0-21.7c-6-6-15.7-6-21.7,0c-6,6-6,15.7,0,21.7C426.8,214.6,436.6,214.6,442.6,208.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M442.9,197.3c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3-0.4-0.6-0.8-0.9-1.2c0,0,0,0,0,0c-1.2-1.4-2.8-2.6-4.5-3.3 c-1.7-0.8-3.6-1.2-5.4-1.2l0,0c-2.3,0-4.6,0.6-6.6,1.8c-2,1.2-3.7,2.8-4.8,4.8c1.2,2,2.8,3.7,4.8,4.8c2,1.2,4.3,1.8,6.6,1.8 c2,0,3.9-0.4,5.6-1.3c1.8-0.8,3.3-2.1,4.6-3.6c0.2-0.2,0.4-0.4,0.5-0.7c0.2-0.2,0.3-0.5,0.5-0.7c0.1-0.1,0.1-0.2,0.2-0.4 C443,197.6,443,197.5,442.9,197.3z M428.4,197.7c0-0.7,0.2-1.3,0.6-1.8c0.4-0.5,0.9-1,1.5-1.2c0.6-0.2,1.3-0.3,1.9-0.2 c0.6,0.1,1.2,0.4,1.7,0.9s0.8,1,0.9,1.7c0.1,0.6,0.1,1.3-0.2,1.9c-0.2,0.6-0.7,1.1-1.2,1.5c-0.5,0.4-1.2,0.6-1.8,0.6 c-0.9,0-1.7-0.3-2.3-1C428.8,199.4,428.4,198.6,428.4,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.1,197.7c0-0.9,0.3-1.8,0.8-2.6c0.5-0.8,1.2-1.3,2.1-1.7c0.8-0.3,1.8-0.4,2.7-0.3c0.9,0.2,1.7,0.6,2.4,1.3 c0.6,0.6,1.1,1.5,1.3,2.4c0.2,0.9,0.1,1.8-0.3,2.7c-0.3,0.8-0.9,1.6-1.7,2.1c-0.8,0.5-1.6,0.8-2.6,0.8c-1.2,0-2.4-0.5-3.2-1.3 C427.6,200.1,427.1,198.9,427.1,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M431.7,199.7c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C429.7,198.8,430.6,199.7,431.7,199.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M396.1,3.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash2);
export default __webpack_public_path__ + "static/media/splash-2.0c2b36ea214055c46e45691ea56a2bcf.svg";
export { ForwardRef as ReactComponent };